module.exports = __webpack_public_path__ + "static/media/catdog.885513cd.svg";